<template>
  <div
    v-if="isLoading"
    class="loading"
  >
    <h3>{{ trans('core.loading') }}</h3>
    <div class="progress">
      <div
        class="progress-bar progress-bar-striped"
        role="progressbar"
        :style="{ width: loadingProgress * 100 + '%' }"
      />
    </div>
  </div>

  <subscriptions-answers-matrix-overview
    v-else
    :subscribables="subscribables"
    :student-subscribables="studentSubscribables"
    :question-template-ids="questionTemplateIds"
    @showFilter="processShowFilter"
  >
    <SubscriptionsAnswersFilter
      slot="filter"
      v-model="filters"
      :api-route="apiRoute"
      :subscribable-grouping-id="subscribableGroupingId"
      :show-filter="showFilter"
    />
  </subscriptions-answers-matrix-overview>
</template>

<script>
import SubscriptionsAnswersMatrixOverview from '@/employees/components/Subscribable/SubscriptionsAnswersMatrixOverview.vue'
import { mapState } from 'vuex'
import { MATRIX_SUBSCRIBABLES_CHUNK_SIZE } from '@/constants'
import SubscriptionsAnswersFilter from '@/employees/components/Subscribable/SubscriptionsAnswersFilter.vue'

export default {
  name: 'SubscribableGroupingAnswersOverview',
  components: { SubscriptionsAnswersFilter, SubscriptionsAnswersMatrixOverview },

  props: {
    apiRoute: {
      required: true,
      type: String,
    },
    subscribableGroupingId: {
      required: false,
      type: String,
      default: null,
    },
  },

  data () {
    return {
      filters: {
        subscribables: [],
        questionTemplates: [],
      },
      loadingProgress: 0,
      isLoading: true,
      showFilter: true,
    }
  },

  computed: {
    ...mapState({
      subscribables (state) {
        return Object.values(state.subscribables.subscribables).filter(subscribable => {
          if (this.filters.subscribables.length > 0) {
            const ids = this.filters.subscribables.map(filtered_subscribable => filtered_subscribable.database_id)

            if (!ids.includes(parseInt(subscribable.id))) {
              return false
            }
          }

          return true
        })
      },

      studentSubscribables (state) {
        return this.subscribables.map(subscribable => subscribable.studentSubscribables)
          .flat()
          .map(studentSubscribableId => {
            const studentSubscribable = state.studentSubscribables.studentSubscribables[studentSubscribableId]

            studentSubscribable.parsed_answers = {}
            studentSubscribable.answers.map(answerId => state.studentSubscribables.studentSubscribableAnswers[answerId])
              .forEach(answer => {
                studentSubscribable.parsed_answers[answer.question_template_id] = answer.parsed_answer
              })

            return studentSubscribable
          })
          .reduce((result, studentSubscribable) => {
            // group the studentSubscribables by studentId
            if (result[studentSubscribable.student] == null) {
              result[studentSubscribable.student] = []
            }

            result[studentSubscribable.student].push(studentSubscribable)

            return result
          }, {})
      },
    }),

    questionTemplateIds () {
      if (this.filters.questionTemplates.length > 0) {
        return this.filters.questionTemplates.map(obj => obj.id)
      }

      return []
    },
  },

  created () {
    this.loadItems()
  },

  methods: {
    async loadItems () {
      this.isLoading = true
      this.loadingProgress = 0
      let subscribableData = []
      let subscribableIds = []
      const calls = []

      // get the subscribable grouping with the subscribables
      await this.$store.dispatch('getSubscribableGroupingSubscribables', {
        subscribableGroupingId: this.subscribableGroupingId,
      }).then((response) => {
        subscribableIds = response.data.data.data.map(subscribable => subscribable.id)
      })

      this.loadingProgress = 0.25

      // split the subscribables of the grouping in chunks for separate calls
      const chunkedSubscribables = _.chunk(subscribableIds, MATRIX_SUBSCRIBABLES_CHUNK_SIZE)
      const singleStepProgression = 0.75 / chunkedSubscribables.length

      // Do a call for each chunk and increment the loading progress
      for (const chunk of chunkedSubscribables) {
        calls.push(this.$store.dispatch('getSubscribables', {
          apiRoute: this.apiRoute,
          queryParams: {
            filter: {
              id: chunk,
            },
          },
        }).then((response) => {
          if (response.student_subscribables) {
            subscribableData = subscribableData.concat(response.student_subscribables)
          }

          this.loadingProgress += singleStepProgression
        }))
      }

      // wait untill all calls are done so we can group the results
      await Promise.all(calls)

      this.isLoading = false
    },

    processShowFilter (event) {
      this.showFilter = event.showFilter
    },
  },
}
</script>

<style scoped lang="scss">
.filter-component {
  padding: 0px;

  .control-label {
    padding: 0px;
  }
}
.filter-component-date {
  .control-label {
    padding-top: 10px;
  }
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1 0 auto;

  .progress {
    width: 75%;
  }
}
</style>
